import { useState, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container, Grid } from '@material-ui/core';
import { NumericFormat } from 'react-number-format';
import { useNavigate } from 'react-router-dom';

import ApiService from 'src/services/ApiService';
import Cookies from 'universal-cookie';
import Constants from 'src/utils/Constants';

import CountCard from 'src/components/dashboard/CountCard';
import AnalyticsAccountList from './account/AnalyticsAccountList';
import { Typography } from '@mui/material';

const Dashboard = () => {
  const [oldTotalWithdrawalsToday, setOldTotalWithdrawalsToday] = useState(0);
  const [oldTotalDepositsToday, setOldTotalDepositsToday] = useState(0);
  const [oldCashBalance, setOldCashBalance] = useState(0);
  const [oldAllTimeWithdrawals, setOldAllTimeWithdrawals] = useState(0);
  const [oldAllTimeDeposits, setOldAllTimeDeposits] = useState(0);

  const [numCustomers, setNumCustomers] = useState(0);
  const [numAccounts, setNumAccounts] = useState(0);
  const [numAgents, setNumAgents] = useState(0);
  // const [numTransactions, setNumTransactions] = useState(0);

  const [totalAllTellersWithdrawalsToday, setTotalAllTellersWithdrawalsToday] = useState(0);
  const [totalAllTellersDepositsToday, setTotalAllTellersDepositsToday] = useState(0);

  const [totalTellerDepositsToday, setTotalTellerDepositsToday] = useState(0);
  const [totalTellerWithdrawalsToday, setTotalTellerWithdrawalsToday] = useState(0);

  const [cashBalance, setCashBalance] = useState(0);
  const [tellerCashBalance, setTellerCashBalance] = useState(0);
  const [cashBalanceWithInitialLoadValue, setCashBalanceWithInitialLoadValue] = useState(0);

  const [alltimeDeposits, setAlltimeDeposits] = useState(0);
  const [allTimeWithdrawals, setAllTimeWithdrawals] = useState(0);
  const [totalMales, setTotalMales] = useState(0);
  const [totalFemales, setTotalFemales] = useState(0);
  const [systemAnalytics, setSystemAnalytics] = useState({
    totalMaleBalances: 0,
    totalFemalesBalances: 0,
    largestTwentyDepositors: [],
    lowestTwentyDepositors: []
  });
  const navigate = useNavigate();

  const cookies = new Cookies();
  const currentUser = cookies.get('umf_user');

  const loadData = useCallback(async () => {
    const customers = await ApiService(currentUser.token).GetCustomers({});
    const accounts = await ApiService(currentUser.token).GetAccounts({});
    const agents = await ApiService(currentUser.token).GetAgents({});

    const cashbalanceAnalytics = await ApiService(currentUser.token).GetCashBalance({
      userId: currentUser._id,
      userType: currentUser.userType
    });

    setTotalMales(customers.data.filter((customer) => customer.gender === 'Male').length);
    setTotalFemales(customers.data.filter((customer) => customer.gender === 'Female').length);
    setNumCustomers(customers.data.length);
    setNumAccounts(accounts.data.length);
    setNumAgents(agents.data.length);

    setCashBalance(cashbalanceAnalytics.data?.payload?.admin?.cashbalance);
    setAlltimeDeposits(cashbalanceAnalytics.data?.payload?.admin?.totalAlltimeDeposits);
    setAllTimeWithdrawals(cashbalanceAnalytics.data?.payload?.admin?.totalAlltimeWithdrawals);
    setTotalAllTellersDepositsToday(
      cashbalanceAnalytics.data?.payload?.admin?.totalAllTellersDepositsToday
    );
    setTotalAllTellersWithdrawalsToday(
      cashbalanceAnalytics.data?.payload?.admin?.totalAllTellersWithdrawalsToday
    );
    setCashBalanceWithInitialLoadValue(
      cashbalanceAnalytics.data?.payload?.admin?.cashBalanceWithInitialLoadValue
    );

    setTellerCashBalance(cashbalanceAnalytics?.data?.payload?.teller?.cashbalance);
    setTotalTellerDepositsToday(
      cashbalanceAnalytics?.data?.payload?.teller?.totalTellerDespositsToday
    );
    setTotalTellerWithdrawalsToday(
      cashbalanceAnalytics?.data?.payload?.teller?.totalTellerWithdrawalsToday
    );

    /*
     * Old Dashboar Data Below...
     */

    const transactions = await ApiService(currentUser.token).GetTransactions({
      userId: currentUser._id,
      userType: currentUser.userType
    });

    setOldTotalDepositsToday(() =>
      transactions.data
        .filter((transaction) => transaction.transactionType === 'DEPOSIT_TRANSACTION')
        .reduce((total, transaction) => total + transaction.transactionAmount, 0)
    );
    setOldTotalWithdrawalsToday(() =>
      transactions.data
        .filter((transaction) => transaction.transactionType === 'WITHDRAWAL_TRANSACTION')
        .reduce((total, transaction) => total + transaction.transactionAmount, 0)
    );
    setOldCashBalance(cashbalanceAnalytics?.data.payload?.old?.cashbalance);
    setOldAllTimeDeposits(cashbalanceAnalytics?.data?.paylod?.old?.totalDeposits);
    setOldAllTimeWithdrawals(cashbalanceAnalytics?.data?.paylod?.old?.totalWithdrawals);

    const analytics = await ApiService(currentUser.token).GetAnalytics({
      userId: currentUser._id,
      userType: currentUser.userType
    });
    setSystemAnalytics(analytics?.data);
  }, [currentUser._id, currentUser.token, currentUser.userType]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (currentUser.userType === Constants.CUSTOMER) {
      navigate('/app/customer/profile', { state: currentUser._id });
    }
  });

  return (
    <>
      <Helmet>
        <title>Dashboard | Unitrans Microfinance</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          pt: 4
        }}
      >
        <Container maxWidth={false}>
          <Grid>
            {/* <Typography sx={{ px: 3, py: 2 }} color="textPrimary" variant="h3">
              Default Dashboard (Old)
            </Typography> */}

            <Grid container spacing={3} mb={5}>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={
                        totalTellerDepositsToday
                          ? 578914.23 + totalTellerDepositsToday - totalTellerWithdrawalsToday
                          : 0
                      }
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Cash Balance'}
                  sx={{ background: '#6AB187' }}
                />
              </Grid>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={oldTotalDepositsToday}
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Total Deposits Today'}
                  sx={{ background: '#484848' }}
                />
              </Grid>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={oldTotalWithdrawalsToday}
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Total Withdrawals Today'}
                  sx={{ background: '#1F3F49' }}
                />
              </Grid>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={oldAllTimeDeposits}
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Total All Time Deposits'}
                  sx={{ background: '#EA6A47' }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} mb={5}>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={oldAllTimeWithdrawals}
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Total All Time Withdrawals'}
                  sx={{ background: '#DBAE58' }}
                />
              </Grid>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={numCustomers}
                  totalname={'Total Customers'}
                  sx={{
                    background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#78BEF2'
                  }}
                  disabled={currentUser.userType !== Constants.ADMIN}
                />
              </Grid>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={numAccounts}
                  totalname={'Total Accounts'}
                  sx={{
                    background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#D32D41'
                  }}
                  disabled={currentUser.userType !== Constants.ADMIN}
                />
              </Grid>
              <Grid item lg={3} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={numAgents}
                  totalname={'Total Tellers'}
                  sx={{
                    background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#7E909A'
                  }}
                  disabled={currentUser.userType !== Constants.ADMIN}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item lg={6} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={totalMales}
                  totalname={'Total Males'}
                  // totalBalance={
                  //   <NumericFormat
                  //     decimalScale={2}
                  //     fixedDecimalScale={true}
                  //     displayType="text"
                  //     value={systemAnalytics?.totalMaleBalances}
                  //     thousandSeparator=","
                  //   />
                  // }
                  sx={{
                    background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#6AB187'
                  }}
                  disabled={currentUser.userType !== Constants.ADMIN}
                />
              </Grid>
              <Grid item lg={6} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={totalFemales}
                  totalname={'Total Females'}
                  // totalBalance={
                  //   <NumericFormat
                  //     decimalScale={2}
                  //     fixedDecimalScale={true}
                  //     displayType="text"
                  //     value={systemAnalytics?.totalFemalesBalances}
                  //     thousandSeparator=","
                  //   />
                  // }
                  sx={{
                    background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#6AB187'
                  }}
                  disabled={currentUser.userType !== Constants.ADMIN}
                />
              </Grid>
            </Grid>
          </Grid>

          {/* <br />
          <br />
          <hr />
          <Grid>
            <Typography sx={{ px: 3, py: 2 }} color="textPrimary" variant="h3">
              Teller (New)
            </Typography>

            <Grid container spacing={3} mb={5}>
              <Grid item lg={4} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={tellerCashBalance}
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Cash Balance'}
                  sx={{ background: '#7E909A' }}
                />
              </Grid>
              <Grid item lg={4} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={totalTellerDepositsToday}
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Total Deposits Today'}
                  sx={{ background: '#7E909A' }}
                />
              </Grid>
              <Grid item lg={4} sm={6} xl={3} xs={12}>
                <CountCard
                  totalcount={
                    <NumericFormat
                      decimalScale={2}
                      fixedDecimalScale={true}
                      displayType="text"
                      value={totalTellerWithdrawalsToday}
                      thousandSeparator=","
                    />
                  }
                  showcurrency="true"
                  totalname={'Total Withdrawals Today'}
                  sx={{ background: '#7E909A' }}
                />
              </Grid>
            </Grid>
          </Grid>

          <br />
          <br />
          <hr />
          {currentUser.userType === Constants.ADMIN ? (
            <Box>
              <Typography sx={{ px: 3, py: 2 }} color="textPrimary" variant="h3">
                Admin (New)
              </Typography>

              <Grid container spacing={3} mb={5}>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={cashBalance}
                        thousandSeparator=","
                      />
                    }
                    showcurrency="true"
                    totalname={'Cash Balance'}
                    sx={{ background: '#1F3F49' }}
                  />
                </Grid>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={totalAllTellersDepositsToday}
                        thousandSeparator=","
                      />
                    }
                    showcurrency="true"
                    totalname={'Total of All Deposits From All Tellers for the day'}
                    sx={{ background: '#6AB187' }}
                  />
                </Grid>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={totalAllTellersWithdrawalsToday}
                        thousandSeparator=","
                      />
                    }
                    showcurrency="true"
                    totalname={'Total of All Withdrawals From All Tellers for the day'}
                    sx={{ background: '#484848' }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mb={5}>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={cashBalanceWithInitialLoadValue}
                        thousandSeparator=","
                      />
                    }
                    showcurrency="true"
                    totalname={'CASH BALANCE BF/AF'}
                    sx={{ background: '#1F3F49' }}
                  />
                </Grid>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={alltimeDeposits}
                        thousandSeparator=","
                      />
                    }
                    showcurrency="true"
                    totalname={'Total All Time Deposits'}
                    sx={{ background: '#6AB187' }}
                  />
                </Grid>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={allTimeWithdrawals}
                        thousandSeparator=","
                      />
                    }
                    showcurrency="true"
                    totalname={'Total All Time Withdrawals'}
                    sx={{ background: '#484848' }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mb={5}>
                <Grid item lg={6} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={totalMales}
                    totalname={'Total Males'}
                    totalBalance={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={systemAnalytics?.totalMaleBalances}
                        thousandSeparator=","
                      />
                    }
                    sx={{
                      background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#DBAE58'
                    }}
                    disabled={currentUser.userType !== Constants.ADMIN}
                  />
                </Grid>
                <Grid item lg={6} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={totalFemales}
                    totalname={'Total Females'}
                    totalBalance={
                      <NumericFormat
                        decimalScale={2}
                        fixedDecimalScale={true}
                        displayType="text"
                        value={systemAnalytics?.totalFemalesBalances}
                        thousandSeparator=","
                      />
                    }
                    sx={{
                      background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#DBAE58'
                    }}
                    disabled={currentUser.userType !== Constants.ADMIN}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mb={5}>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={numCustomers}
                    totalname={'Total Customers'}
                    sx={{
                      background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#78BEF2'
                    }}
                    disabled={currentUser.userType !== Constants.ADMIN}
                  />
                </Grid>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={numAccounts}
                    totalname={'Total Accounts'}
                    sx={{
                      background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#D32D41'
                    }}
                    disabled={currentUser.userType !== Constants.ADMIN}
                  />
                </Grid>
                <Grid item lg={4} sm={6} xl={3} xs={12}>
                  <CountCard
                    totalcount={numAgents}
                    totalname={'Total Tellers'}
                    sx={{
                      background: currentUser.userType !== Constants.ADMIN ? '#ccc' : '#7E909A'
                    }}
                    disabled={currentUser.userType !== Constants.ADMIN}
                  />
                </Grid>
              </Grid>
            </Box>
          ) : null} */}

          {currentUser.userType === Constants.ADMIN ? (
            <Box>
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                  <Typography sx={{ px: 3, py: 2 }} color="textPrimary" variant="h3">
                    20 Largest Depositors
                  </Typography>
                  <AnalyticsAccountList accounts={systemAnalytics.largestTwentyDepositors} />
                </Grid>
              </Grid>
              <Grid container spacing={3} sx={{ mt: 2 }}>
                <Grid item lg={12} sm={12} xl={12} xs={12}>
                  <Typography sx={{ px: 3, py: 2 }} color="textPrimary" variant="h3">
                    20 Lowest Depositors
                  </Typography>
                  <AnalyticsAccountList accounts={systemAnalytics.lowestTwentyDepositors} />
                </Grid>
              </Grid>
            </Box>
          ) : null}
        </Container>
      </Box>
      {/* <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%'
        }}
      >
        <Container maxWidth={false}>

        </Container>
      </Box> */}
    </>
  );
};

export default Dashboard;
